'use client';

import React__default, { useState } from 'react';
import Button from '../Button/index.js';
import { PaginationWrapper } from './Pagination.css.js';
import ThreeDotIcon from '../Images/ThreeDotIcon/index.js';
import '../Images/AddIcon/index.js';
import '../Images/AddOutlinedIcon/index.js';
import '../Images/Trash/index.js';
import '../Images/Pencil/index.js';
import '../_virtual/_tslib.js';
import '../Images/ArrowRoundedLeft/index.js';
import '../Images/ArrowRoundedRight/index.js';
import '../Images/AwardsIcon/index.js';
import '../Images/BonusIcon/index.js';
import '../Images/CanteenIcon/index.js';
import '../Images/CheckTagIcon/index.js';
import '../Images/CommercialIcon/index.js';
import '../Images/CompanySizeIcon/index.js';
import '../Images/ContactIcon/index.js';
import '../Images/CopyIcon/index.js';
import '../Images/DefaultAvatar/index.js';
import '../Images/DangerIcon/index.js';
import '../Images/ExternalLinkIcon/index.js';
import '../Images/FacebookIcon/index.js';
import '../Images/ForwardIcon/index.js';
import '../Images/HealthcarePlanIcon/index.js';
import '../Images/HeartIcon/index.js';
import '../Images/HeartOutlineIcon/index.js';
import '../Images/HideIcon/index.js';
import '../Images/KindergartenIcon/index.js';
import '../Images/LaptopIcon/index.js';
import '../Images/LibraryIcon/index.js';
import '../Images/LinkIcon/index.js';
import '../Images/LinkedInIcon/index.js';
import '../Images/LoadingCircleIcon/index.js';
import '../Images/MarkerIcon/index.js';
import '../Images/MobileIcon/index.js';
import '../Images/PaidLeaveIcon/index.js';
import '../Utils/constants.js';
import '../Images/SearchIcon/index.js';
import '../Images/ShareIcon/index.js';
import '../Images/ReportIcon/index.js';
import '../Images/StatsIcon/index.js';
import '../Images/TeamActivitiesIcon/index.js';
import '../Images/TrainingIcon/index.js';
import '../Images/TransportationIcon/index.js';
import '../Images/TrashIcon/index.js';
import '../Images/TravelOpportunitiesIcon/index.js';
import '../Colors/index.js';
import '../Images/VerticalMoreIcon/index.js';
import '../Images/VoucherIcon/index.js';
import '../Images/WowCVIcon/index.js';
import '../Images/WorkingLocationIcon/index.js';
import '../Images/ZaloIcon/index.js';
import { ArrowLeft, ArrowRight } from '../Images/Arrows/index.js';
import '../Images/FacebookLogoIcon/index.js';
import '../Images/GoogleLogoIcon/index.js';
import '../Images/DragReorderIcon/index.js';
import '../Images/CheckIcon/index.js';
import '../Images/CircleChecked/index.js';
import '../Images/SalaryIcon/index.js';
import '../Images/BriefcaseIcon/index.js';
import '../Images/GraduationCapIcon/index.js';
import '../Images/EnvelopeIcon/index.js';
import '../Images/AddFilledIcon/index.js';
import '../Images/HomeIcon/index.js';
import '../Images/PhoneIcon/index.js';
import '../Images/AttachIcon/index.js';
import '../Images/FilterIcon/index.js';
import '../icons/WarnIcon.js';
import '../icons/AccountSettingsIcon.js';
import '../icons/DashboardIcon.js';
import '../icons/JobAlertsIcon.js';
import '../icons/MyCompaniesIcon.js';
import '../icons/MyJobsIcon.js';
import '../icons/MyProfileIcon.js';
import '../icons/ProfileSettingsIcon.js';
import '../icons/LanguageIcon.js';
import '../icons/BenefitGroupIcons/ActivityIcon.js';
import '../icons/BenefitGroupIcons/AwardsIcon.js';
import '../icons/BenefitGroupIcons/BonusIcon.js';
import '../icons/BenefitGroupIcons/CanteenIcon.js';
import '../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../icons/BenefitGroupIcons/LaptopIcon.js';
import '../icons/BenefitGroupIcons/LibraryIcon.js';
import '../icons/BenefitGroupIcons/MoreIcon.js';
import '../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../icons/BenefitGroupIcons/PhoneIcon.js';
import '../icons/BenefitGroupIcons/TrainingIcon.js';
import '../icons/BenefitGroupIcons/TransportationIcon.js';
import '../icons/BenefitGroupIcons/TravelIcon.js';
import '../icons/BenefitGroupIcons/VoucherIcon.js';
import '../icons/BenefitGroupIcons/Physics.js';
import '../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../icons/AccountCenterGroupIcons/Language.js';
import '../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../icons/AccountCenterGroupIcons/Lawyer.js';
import '../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../icons/InfoOverviewGroupIcons/Location.js';
import '../icons/InfoOverviewGroupIcons/Education.js';
import '../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/Admin.js';
import '../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../icons/InfoOverviewGroupIcons/Address.js';
import '../icons/InfoOverviewGroupIcons/Salary.js';
import '../icons/InfoOverviewGroupIcons/Gender.js';
import '../icons/InfoOverviewGroupIcons/Translator.js';
import '../icons/InfoOverviewGroupIcons/Birthday.js';
import '../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../icons/MiscGroupIcons/Link.js';
import '../icons/MiscGroupIcons/History.js';
import '../icons/MiscGroupIcons/Favorite.js';
import '../icons/MiscGroupIcons/UnFavorite.js';
import '../icons/MiscGroupIcons/ProductDocuments.js';
import '../icons/MiscGroupIcons/Star.js';
import '../icons/SocialMediaGroupIcons/Facebook.js';
import '../icons/SocialMediaGroupIcons/Linkedin.js';
import '../icons/SocialMediaGroupIcons/Twitter.js';
import '../icons/SocialMediaGroupIcons/Zalo.js';
import '../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../icons/SocialMediaGroupIcons/Share.js';
import '../icons/NavigationGroupIcons/Vertical.js';
import '../icons/NavigationGroupIcons/More.js';
import '../icons/NavigationGroupIcons/Close.js';
import '../icons/NavigationGroupIcons/Expand.js';
import '../icons/NavigationGroupIcons/Collapse.js';
import '../icons/NavigationGroupIcons/Next.js';
import '../icons/NavigationGroupIcons/Back.js';
import '../icons/NavigationGroupIcons/ExternalLink.js';
import '../icons/NavigationGroupIcons/RightArrow.js';
import '../icons/AlertGroupIcons/SuccessIcon.js';
import '../icons/AlertGroupIcons/CareerPath.js';
import '../icons/AlertGroupIcons/Hot.js';
import '../icons/AlertGroupIcons/Urgent.js';
import '../icons/FormActionGroupIcons/Exchange.js';
import '../icons/FormActionGroupIcons/AddTag.js';
import '../icons/RewardsTypeGroupIcons/Hospital.js';
import '../Images/DoubleTickIcon/index.js';
import '../Images/BellIcon/index.js';
import '../Images/AiIcon/index.js';
import '../Images/MiniAiIcon/index.js';
import '../icons/OrderManagementIcon.js';
import '../Images/TwinkleLinearGradientIcon/index.js';

var Pagination = function (props) {
    var current = props.current, total = props.total, onGoTo = props.onGoTo;
    var _a = useState(current), currentPage = _a[0], setCurrentPage = _a[1];
    var isShowPrevious = false;
    var isShowNext = false;
    // Make a list of pagination
    var displayPage = [];
    if (currentPage - 1 > 0) {
        displayPage.push(current - 1);
    }
    displayPage.push(current);
    if (currentPage + 1 <= total) {
        displayPage.push(current + 1);
    }
    // Show more left (3 dots)
    var isShowMoreLeft = false;
    if (displayPage.indexOf(1) < 0) {
        isShowMoreLeft = true;
        isShowPrevious = true;
    }
    if (displayPage.indexOf(3) > 0) {
        isShowMoreLeft = false;
    }
    // Show more right (3 dots)
    var isShowMoreRight = false;
    if (displayPage.indexOf(total) < 0) {
        isShowMoreRight = true;
        isShowNext = true;
    }
    if (displayPage.indexOf(total - 1) > 0) {
        isShowMoreRight = false;
    }
    return (React__default.createElement(PaginationWrapper, null,
        isShowPrevious ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, iconComponent: React__default.createElement(ArrowLeft, null), onClick: function () {
                    var previousPage = current - 1;
                    onGoTo && onGoTo(current - 1);
                    setCurrentPage(previousPage);
                } }),
            React__default.createElement(Button, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, onClick: function () {
                    onGoTo && onGoTo(1);
                    setCurrentPage(1);
                } }, "1"))) : null,
        isShowMoreLeft ? (React__default.createElement(Button, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, disabled: true, iconComponent: React__default.createElement(ThreeDotIcon, null) })) : null,
        displayPage.map(function (item) {
            return (React__default.createElement(Button, { key: "page-".concat(item), type: 'highlight', className: currentPage === item ? 'current' : '', outline: 'none', isIcon: true, isRounded: true, disabled: currentPage === item, onClick: function () {
                    onGoTo && onGoTo(item);
                    setCurrentPage(item);
                } }, item));
        }),
        isShowMoreRight ? (React__default.createElement(Button, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, disabled: true, iconComponent: React__default.createElement(ThreeDotIcon, null) })) : null,
        isShowNext ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, onClick: function () {
                    onGoTo && onGoTo(total);
                    setCurrentPage(total);
                } }, total),
            React__default.createElement(Button, { type: 'highlight', outline: 'none', isIcon: true, isRounded: true, iconComponent: React__default.createElement(ArrowRight, null), onClick: function () {
                    var nextPage = current + 1;
                    onGoTo && onGoTo(nextPage);
                    setCurrentPage(nextPage);
                } }))) : null));
};

export { Pagination as default };
//# sourceMappingURL=index.js.map
